export enum WorkoutMode {
  Practice = 'practice',
  Test = 'test',
  Workout = 'workout',
  Learning = 'learning',
}

export interface IBaseOptions {
  difficulty: number;
  mode: WorkoutMode;
  options?: any;
}

export interface AssessmentPracticeOptions extends IBaseOptions {
  mode: WorkoutMode.Practice;
}

export interface AssessmentTestOptions extends IBaseOptions {
  mode: WorkoutMode.Test;
}

export interface IStatState {
  payload: { valueInt?: number; valueTxt: string }; // userStat payload in form of {"valueInt":...,"valueTxt":"..."}
}

export interface ITutorialStatState extends IStatState {
  lastEdit: number; // unix timestamp
}

export interface ExerciseWorkoutOptions extends IBaseOptions {
  goal?: number;
  assessmentRun?: number;
  exerciseRun?: number;
  tutorial?: ITutorialStatState;
  messagesReadState?: IStatState;
  showSolutionWithConfirmState?: IStatState;
  mode: WorkoutMode.Workout | WorkoutMode.Learning;
}

export type WorkoutRuntimeOptions = AssessmentPracticeOptions | AssessmentTestOptions | ExerciseWorkoutOptions;
